export type BinaryArray = [0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1, 0 | 1]

export const LightBar = ({
  lights = [0, 0, 0, 0, 0, 0, 0],
}: {
  lights: BinaryArray
}) => {
  return (
    <div className="w-full h-8 counter-gradient rounded-full p-px overflow-hidden">
      <div className="grid grid-pile absolute inset-0 pointer-events-none">
        <div className="z-10 rounded-card-bg md:rounded-card-bg-lg blur-sm border-2 border-green group-hover/card:opacity-[5%] opacity-0 transition duration-1000 ease-expo-out "></div>
        <div className="z-10 rounded-card-bg md:rounded-card-bg-lg green-fade-out group-hover/card:opacity-[5%] opacity-0 transition duration-1000 ease-expo-out "></div>
      </div>
      <div className="w-full h-full blue-fade-out rounded-full p-1 flex flex-row items-center justify-around">
        {Array.from({ length: 7 }).map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full relative ${lights[index] ? `animate-pulse-stagger-${index}` : ''}`}
          >
            <div className="grid grid-pile absolute inset-0 pointer-events-none">
              <div
                className={`
                z-20 rounded-full bg-white transition duration-1000 ease-expo-out w-1 h-1 ml-0.5 mt-0.5 blur-[1px]
                ${lights[index] ? 'opacity-100' : 'opacity-20'}
              `}
              ></div>
              <div
                className={`
                z-10 rounded-full blur-[4px] bg-green transition duration-1000 ease-expo-out
                ${lights[index] ? 'opacity-100' : 'opacity-20'}
              `}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
